export const LINKS = {
  whatsapp: "https://wa.me/393453268332?text=Ciao!%20Vorrei%20informazioni%20e%20disponibilit%C3%A0%20per%20Borgo%20DiVino",
  airbnb: "https://www.airbnb.it/hosting/listings/editor/1244781937302795127/details/custom-link",
  booking: "https://www.booking.com/hotel/it/borgo-divino-marino.it.html",
};
